import { TicketSource } from "../models/freshworks";

const FRESHDESK_SUPPORT_WIDGET_IFRAME_SOURCE_URL_PREFIX: string = 'https://fakturomania.freshdesk.com/widgets/feedback_widget/new?&widgetType=embedded&widgetView=no&searchArea=no';
const FORM_TITLE_PREFIX: string = 'formTitle=FORMULARZ KONTAKTOWY';
const SUBMIT_BUTTON_NAME_PREFIX: string = 'submitTitle=Wyślij';
const SUBMIT_MESSAGE_PREFIX: string = 'submitThanks=Dziękujemy za przesłanie zgłoszenia!';
export const BIURO_RACHUNKOWE_PAGE_FORM_IFRAME_SOURCE_URL: string = prepareIframeSourceUrl(TicketSource.BiuroRachunkowe);
export const ZAKLADANIE_SPOLEK_PAGE_FORM_IFRAME_SOURCE_URL: string = prepareIframeSourceUrl(TicketSource.ZakladanieSpolek);
export const KONTAKT_PAGE_FORM_IFRAME_SOURCE_URL: string = prepareIframeSourceUrl(TicketSource.Kontakt);

/** FUNKCJE POMOCNICZE */

function prepareIframeSourceUrl(formSource: TicketSource): string {
  // DANE UNIVERSALNE
  const ID_FIRMA_SRC_PART: string = prepareFieldFormQueryString('cf_companyid_817316',0,true);
  const ZRODLO_SRC_PART: string = prepareFieldFormQueryString('cf_zrodlo_817316',formSource,true);

  // ŁĄCZENIE PARTÓW
  const widgedSourceSrcList: string[] = [
    FRESHDESK_SUPPORT_WIDGET_IFRAME_SOURCE_URL_PREFIX,
    FORM_TITLE_PREFIX,
    SUBMIT_BUTTON_NAME_PREFIX,
    SUBMIT_MESSAGE_PREFIX,
    ID_FIRMA_SRC_PART,
    ZRODLO_SRC_PART,
  ];

  // SKŁADANIE URL
  return widgedSourceSrcList.join('&')
}

function prepareFieldFormQueryString(fieldName: string, fieldValue: string | number, disabled: boolean): string {
  // JEZELI NIE JEST ZABLOKOWANE
  if (!disabled) {
    return `helpdesk_ticket[custom_field][${fieldName}]=${fieldValue}`
  }

  // JEZELI JEST ZABLOKOWANE
  else {
    return `helpdesk_ticket[custom_field][${fieldName}]=${fieldValue}&disable[custom_field][${fieldName}]=true`
  }
}


// WEBPACK FOOTER //
// ./src/constants/freshworks-data.ts